import { Popover } from '@headlessui/react';
import { FiltersDto } from 'components/common/ComposableFilters/FiltersDto';
import { ButtonCTASmall, LoadingSpinner } from 'components/ui';
import querystring from 'querystring';
import { useState } from 'react';
import { usePopper } from 'react-popper';
import { FilterProps } from 'store/composableFiltersSlice';
import { useSaveSegmentMutation } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';

export const ReplenishmentSaveSegment = ({
  productTitle,
}: {
  productTitle: string | undefined;
}) => {
  const [segmentName, setSegmentName] = useState('');
  const [description, setDescription] = useState('');

  let [referenceElement, setReferenceElement] = useState();
  let [popperElement, setPopperElement] = useState();
  let { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom',
  });

  const { query } = useParseURLQueryParams();

  const [saveSegment, { isLoading }] = useSaveSegmentMutation();

  const selectedFilters = {
    mainOperator: 'and',
    conditions: [
      {
        property: {
          name: 'product_title',
          display: 'Product title',
        },
        operator: {
          name: 'contains',
          display: 'contains',
        },
        value: [
          {
            value: productTitle,
            label: productTitle,
          },
        ],
        key: Math.random(),
      },
      {
        property: {
          name: 'orders',
          display: 'Orders',
        },
        operator: {
          name: 'equal',
          display: '=',
        },
        value: 1,
        key: Math.random(),
      },
    ],
  };

  const handleSaveSegment = async (close: Function) => {
    if (!!!segmentName) return;

    const params = querystring.stringify({
      store_name: query.store_name,
      description: description,
      segment_name: segmentName,
    });

    const body = new FiltersDto(
      selectedFilters as FilterProps
    ).generateBodyPayload();

    saveSegment({ serializedParams: params, body })
      .unwrap()
      .then(() => {
        setSegmentName('');
        setDescription('');
        close();
      });
  };

  return (
    <Popover className="">
      {({ open, close }) => (
        <>
          <Popover.Button
            //@ts-ignore
            ref={setReferenceElement}
            className="font-bold text-segments-link "
          >
            Create segment
          </Popover.Button>
          <Popover.Overlay
            className={`${
              open ? 'opacity-30 fixed inset-0' : 'opacity-0'
            } bg-black`}
          />

          <Popover.Panel
            // @ts-ignore
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
            className="z-10 w-screen max-w-sm mt-2 lg:max-w-md "
          >
            <div className="bg-white shadow-2xl rounded-3xl ring-1 ring-black ring-opacity-5">
              <div className="pt-6 px-7">
                <p className="font-bold">Save as a new segment</p>
              </div>
              <form
                className="px-6 py-2 text-gray-700"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSaveSegment(close);
                }}
              >
                <div className="mt-2 space-y-4">
                  <input
                    tabIndex={0}
                    type="text"
                    id="segment-name"
                    className="flex-1 w-full h-12 px-5 placeholder-black border border-black border-solid border-opacity-20 rounded-segments-10px placeholder-opacity-30 focus:border-segments-accent-color-1 focus:ring-segments-accent-color-1 disabled:bg-segments-gray"
                    value={segmentName}
                    onChange={(e) => setSegmentName(e.target.value)}
                    spellCheck="false"
                    required
                    placeholder="Name"
                  />
                  <div tabIndex={1}>
                    <input
                      type="text"
                      id="segment-description"
                      className="flex-1 w-full h-12 px-5 placeholder-black border border-black border-solid border-opacity-20 rounded-segments-10px placeholder-opacity-30 focus:border-segments-accent-color-1 focus:ring-segments-accent-color-1 disabled:bg-segments-gray"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      spellCheck="false"
                      placeholder="Description"
                    />
                  </div>
                </div>

                <div className="flex justify-end mt-4 mb-4 space-x-4">
                  <div>
                    <ButtonCTASmall
                      variant="secondary"
                      type="button"
                      onClick={() => {
                        close();
                      }}
                    >
                      <p className="px-4 font-normal text-segments-13px">
                        Cancel
                      </p>
                    </ButtonCTASmall>
                  </div>
                  <div>
                    <ButtonCTASmall
                      variant="main"
                      type="submit"
                      disabled={!!!segmentName}
                    >
                      <div className="w-20 font-bold text-segments-13px">
                        {isLoading ? (
                          <LoadingSpinner className="w-5 h-5 mx-auto text-white" />
                        ) : (
                          'Save'
                        )}
                      </div>
                    </ButtonCTASmall>
                  </div>
                </div>
              </form>
            </div>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
};
